export default __webpack_public_path__ + "static/media/03-assumption-maping.ba226fea.png";